import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, TextField, Typography, Button } from "@material-ui/core";
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
    card: {
        minWidth: '80%',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        padding: 20,
    },
    input: {
        marginBottom: 20,
    },
});

const CreateBus = ({ onAdded, onSelectItem }) => {
    const classes = useStyles();

    // State for storing the form input values
    const [staffId, setStaffId] = useState('');
    const [deviceId, setDeviceId] = useState('');
    const [routeIds, setRouteIds] = useState([]);
    const [name, setName] = useState('');

    // State for storing the location options from the location API
    const [staffOptions, setStaffOptions] = useState([]);
    const [deviceOptions, setDeviceOptions] = useState([]);
    const [routeOptions, setRouteOptions] = useState([]);

    // Effect to fetch location options from the location API on component mount
    useEffect(() => {
        fetch('http://biometick.com/all-staff/' + localStorage.getItem("userID"), {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.length > 0) {
                    setStaffOptions(data);
                }
            }).catch(error => console.error(error));
        fetch('http://biometick.com/get-devices/' + localStorage.getItem("userID"), {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.length > 0) {
                    setDeviceOptions(data);
                }
            }).catch(error => console.error(error));
        fetch('http://biometick.com/all-routes/' + localStorage.getItem("userID"), {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.length > 0) {
                    setRouteOptions(data);
                }
            }).catch(error => console.error(error));
    }, []);

    const handleCreate = async () => {
        try {
            console.log(localStorage.getItem("token"));
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            var urlencoded = new URLSearchParams();
            urlencoded.append("name", name);
            urlencoded.append("staffId", staffId);
            urlencoded.append("userID", localStorage.getItem("userID"));
            urlencoded.append("deviceId", deviceId);
            urlencoded.append("routeIds", JSON.stringify(routeIds));
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: urlencoded,
                redirect: 'follow'
            };
            fetch("http://biometick.com/buses", requestOptions)
                .then(response => response.text())
                .then(result => {
                    console.log(result);
                    result = JSON.parse(result);
                    if (result.hasOwnProperty('_id')) {
                        onAdded('read');
                    } else {
                        console.log('Some error occured while saving.');
                    }
                })
                .catch(error => console.log('error', error));
        } catch (error) {
            console.log(error);
        }
    };

    // Handle form input change
    const handleInputChange = (event) => {
        const { name, value } = event.target;

        if (name === 'staffId') {
            setStaffId(value);
        } else if (name === 'deviceId') {
            setDeviceId(value);
        } else if (name === 'routeIds') {
            setRouteIds((array) => {
                var list = [...array, ...event.target.value]
                list = list.filter((value, index, self) => self.indexOf(value) === index)
                return list;
            });
        } else if (name === 'name') {
            setName(value);
        }
    };


    return (<div className={classes.root} style={{ minWidth: '100%', display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Card className={classes.card}>
            <CardContent>
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                    <TextField
                        label="Name"
                        name="name"
                        value={name}
                        onChange={handleInputChange}
                        variant="outlined"
                        className={classes.input}
                        fullWidth
                        margin={'10px'}
                        required
                    />
                    <div style={{ width: '10px' }} />
                    <TextField
                        select
                        label="Staff"
                        name="staffId"
                        variant="outlined"
                        className={classes.input}
                        fullWidth
                        margin={'10px'}
                        value={staffId}
                        onChange={handleInputChange}
                        required
                    >
                        {staffOptions.map((option) => (
                            <MenuItem key={option._id} value={option._id}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                    <TextField
                        select
                        label="Device"
                        name="deviceId"
                        variant="outlined"
                        className={classes.input}
                        fullWidth
                        margin={'10px'}
                        value={deviceId}
                        onChange={handleInputChange}
                        required
                    >
                        {deviceOptions.map((option) => (
                            <MenuItem key={option._id} value={option._id}>
                                {option.deviceName}
                            </MenuItem>
                        ))}
                    </TextField>
                    <div style={{ width: '10px' }} />
                    <div style={{ flexDirection: 'column', width: '100%', display: 'flex', marginBottom: 20, }}>

                        <TextField
                            select
                            label="Routes"
                            name="routeIds"
                            variant="outlined"
                            fullWidth
                            margin={'10px'}
                            SelectProps={{ multiple: true }}
                            value={routeIds}
                            onChange={handleInputChange}
                            required>
                            {routeOptions.map((option) => (
                                <MenuItem key={option._id} value={option._id}>
                                    {option.name}
                                </MenuItem>
                            ))}
                        </TextField>
                        <p style={{ padding: '0px', margin: '0px', color: 'blue' }} onClick={() => {
                            setRouteIds([]);
                        }}>Clear Route List</p>
                    </div>
                </div>
                <Button variant="contained" style={{ height: '45px' }} color="primary" fullWidth onClick={handleCreate}>
                    Create
                </Button>
            </CardContent>
        </Card>
    </div>
    );
};

export default CreateBus;
